<template>
  <div class="experience-chart">
    <Doughnut
      v-if="loaded"
      :data="chartData"
      :options="chartOptions"
      :height="200"
    />
    <div v-else class="d-flex justify-center align-center" style="height: 200px;">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { Doughnut } from 'vue-chartjs'
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title
} from 'chart.js'
import { useHRStore } from '@/stores/hr'

ChartJS.register(ArcElement, Tooltip, Legend, Title)

const hrStore = useHRStore()
const loaded = ref(false)

const experienceData = ref([
  { label: 'Junior (0-2 ans)', value: 25, color: '#4CAF50' },
  { label: 'Intermédiaire (2-5 ans)', value: 35, color: '#2196F3' },
  { label: 'Senior (5-10 ans)', value: 30, color: '#FF9800' },
  { label: 'Expert (10+ ans)', value: 10, color: '#9C27B0' }
])

const chartData = computed(() => ({
  labels: experienceData.value.map(item => item.label),
  datasets: [
    {
      data: experienceData.value.map(item => item.value),
      backgroundColor: experienceData.value.map(item => item.color),
      borderWidth: 2,
      borderColor: '#ffffff',
      hoverBackgroundColor: experienceData.value.map(item => item.color + 'CC'),
      hoverBorderWidth: 3
    }
  ]
}))

const chartOptions = computed(() => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        padding: 20,
        usePointStyle: true,
        font: {
          size: 12
        }
      }
    },
    tooltip: {
      callbacks: {
        label: function(context) {
          const label = context.label || ''
          const value = context.parsed || 0
          const total = context.dataset.data.reduce((a, b) => a + b, 0)
          const percentage = ((value / total) * 100).toFixed(1)
          return `${label}: ${value} candidats (${percentage}%)`
        }
      }
    }
  },
  cutout: '60%',
  animation: {
    animateRotate: true,
    duration: 1000
  }
}))

const loadData = async () => {
  try {
    // Simulate API call - replace with actual data from store
    await new Promise(resolve => setTimeout(resolve, 500))
    
    // TODO: Replace with real data from hrStore.getCandidatesByExperience()
    // const data = await hrStore.getCandidatesByExperience()
    // experienceData.value = data
    
    loaded.value = true
  } catch (error) {
    console.error('Erreur lors du chargement des données d\'expérience:', error)
    loaded.value = true
  }
}

onMounted(() => {
  loadData()
})
</script>

<style scoped>
.experience-chart {
  height: 200px;
}
</style>
